import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		dark: false,
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#042B60',
				secondary: '#00539f',
				accent: '#ea5b0c',
				error: '#8b0d1b',
				info: '#4863a8',
				success: '#95c11f',
				warning: '#fdc300',
				background: '#d9e2ea',
			},
			dark: {
				primary: '#042B60',
				secondary: '#00B0FF',
				accent: '#ea5b0c',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
				background: '#001737',
			},
		},
	},
	icons: {
		iconfont: 'mdi',
	},
})
